import { useAccount } from 'wagmi';
import { useEffect } from 'react';

const useTwitterBindAutoClear = () => {
  const { isConnected } = useAccount();

  useEffect(() => {
    if (!isConnected) {
      console.info('[Twitter Bind] Wallet disconnected, clearing local binding cache...');
      localStorage.removeItem('twitterAvatar');
      localStorage.removeItem('twitterUsername');
      localStorage.setItem('twitterBound', 'false');
    }
  }, [isConnected]);
};

export default useTwitterBindAutoClear;
